/**
 * AboutFAQ.tsx — Gold Garage Door / About Us · Section 9/10
 * Navy · accordion FAQ + JSON-LD FAQPage schema (SEO rich result).
 *
 * 10WEB AI: keep the <script type="application/ld+json"> exactly. Keep inline SVG.
 *    Wave dividers intentional — do NOT strip.
 */

import { useState } from "react";
const NAVY = "#081438";
const GOLD = "#F5A623";
const FAQS = [{
  q: "Are you really a family business?",
  a: "Yes — Gold Garage Door has been family-owned and operated since 2009, based in Bass Hill NSW. The people who answer the phone are the same people who turn up to your job. No franchise, no call centre."
}, {
  q: "Which areas of Sydney do you cover?",
  a: "We service 217+ suburbs across Sydney, from Canterbury-Bankstown (our home turf) out to Western Sydney, the Eastern Suburbs, the Sutherland Shire, North Shore, Northern Beaches, Hills District and beyond."
}, {
  q: "Do you do both repairs and new installations?",
  a: "Both. We handle garage door repairs, spring and cable replacement, motor and opener repair, remote programming, annual servicing, and full new-door installs — sectional, roller, tilt and insulated."
}, {
  q: "Do you work on commercial garage doors too?",
  a: "Yes. Alongside residential work we service strata, real estate and commercial sites — including heavy-duty roller shutters and high-lift industrial doors."
}, {
  q: "What warranty do you offer?",
  a: "Every repair and installation is backed by our 1-Year Labour Warranty. If our workmanship fails within that period, we come back and make it right."
}, {
  q: "How do I get a quote?",
  a: "Call 0485 000 933, message us on WhatsApp, or request a free quote through the site. We give fixed-price quotes up front — the price we quote is the price you pay."
}];
function Item({
  f,
  open,
  onClick
}) {
  return <div style={{
    borderBottom: "1px solid rgba(255,255,255,0.1)"
  }}>
      <button onClick={onClick} style={{
      width: "100%",
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "1.35rem 0",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "1rem",
      textAlign: "left"
    }}>
        <span style={{
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        fontWeight: 700,
        fontSize: "1.05rem",
        color: "#fff"
      }}>{f.q}</span>
        <span aria-hidden style={{
        flexShrink: 0,
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        border: `1.5px solid ${GOLD}`,
        color: GOLD,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.2rem",
        transform: open ? "rotate(45deg)" : "none",
        transition: "transform 0.25s ease"
      }}>+</span>
      </button>
      <div style={{
      maxHeight: open ? "320px" : "0",
      overflow: "hidden",
      transition: "max-height 0.3s ease"
    }}>
        <p style={{
        fontFamily: "'Manrope', sans-serif",
        fontSize: "0.98rem",
        color: "rgba(255,255,255,0.72)",
        lineHeight: 1.7,
        paddingBottom: "1.35rem",
        margin: 0,
        maxWidth: "640px"
      }}>{f.a}</p>
      </div>
    </div>;
}
export default function AboutFAQ() {
  const [open, setOpen] = useState(0);
  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map(f => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.a
      }
    }))
  };
  return <section id="about-faq" style={{
    background: `radial-gradient(ellipse at 70% 100%, #14254d 0%, ${NAVY} 55%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "5.5rem",
    paddingBottom: "5.5rem"
  }}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} />

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      lineHeight: 0,
      transform: "rotate(180deg)"
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}>
          <path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" />
        </svg>
      </div>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}>
        <filter id="grain-af"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#grain-af)" />
      </svg>

      <div aria-hidden style={{
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      right: "-1rem",
      bottom: "2rem",
      fontSize: "11rem",
      fontWeight: 900,
      color: `${GOLD}0D`,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      lineHeight: 1,
      userSelect: "none",
      pointerEvents: "none"
    }}>09</div>

      <div style={{
      maxWidth: "820px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        <div style={{
        textAlign: "center",
        marginBottom: "2.5rem"
      }}>
          <span style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "0.72rem",
          fontWeight: 700,
          letterSpacing: "0.16em",
          color: GOLD,
          textTransform: "uppercase"
        }}>Good To Know</span>
          <h2 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.75rem, 3vw, 2.6rem)",
          color: "#FFFFFF",
          lineHeight: 1.15,
          margin: "0.75rem 0 0"
        }}>
            About Gold Garage Door
          </h2>
        </div>

        <div>
          {FAQS.map((f, i) => <Item key={i} f={f} open={open === i} onClick={() => setOpen(open === i ? -1 : i)} />)}
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}>
          <path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" />
        </svg>
      </div>
    </section>;
}